export default {"src":"/_next/static/media/HelpQuestion.0e8484ba.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};